import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsSection = () => {
  const stats = [
    {
      icon: "Briefcase",
      value: "223+",
      label: "Projects Delivered",
      description: "Across diverse industries"
    },
    {
      icon: "Users",
      value: "196+",
      label: "Happy Clients",
      description: "Long-term partnerships"
    },
    {
      icon: "TrendingUp",
      value: "95%",
      label: "Success Rate",
      description: "Measurable outcomes"
    },
    {
      icon: "Award",
      value: "13+",
      label: "Years Experience",
      description: "Industry expertise"
    }
  ];

  return (
    <div className="bg-gradient-to-br from-primary to-secondary rounded-xl shadow-xl p-6 md:p-8 lg:p-12 mb-8 md:mb-12 lg:mb-16">
      <div className="text-center mb-8 md:mb-10 lg:mb-12">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-3 md:mb-4 font-heading">
          Proven Track Record
        </h2>
        <p className="text-sm md:text-base lg:text-lg text-white/90 max-w-2xl mx-auto">
          Our success stories speak for themselves. Real results, measurable impact, lasting partnerships.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 lg:gap-8">
        {stats?.map((stat, index) => (
          <div
            key={index}
            className="bg-white/10 backdrop-blur-sm rounded-xl p-4 md:p-6 text-center hover:bg-white/20 transition-all duration-300"
          >
            <div className="w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 rounded-full bg-white/20 flex items-center justify-center mx-auto mb-3 md:mb-4">
              <Icon name={stat?.icon} size={24} color="#ffffff" />
            </div>
            <div className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-2">
              {stat?.value}
            </div>
            <div className="text-sm md:text-base lg:text-lg font-semibold text-white mb-1">
              {stat?.label}
            </div>
            <div className="text-xs md:text-sm text-white/80">
              {stat?.description}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatsSection;